<div class="notification border-bottom">
  <div class="container notification__content">
    <div class="row">
      <div class="col-lg-8 d-flex">
        <crnt-icon
          class="me-2 lh-base"
          icon="circle-exclamation"
          size="medium"
        />
        @if (showMessage() && message(); as message) {
          <wl-rich-text-wrapper [field]="message">
            <div role="status"></div>
          </wl-rich-text-wrapper>
        }
      </div>
    </div>
  </div>
</div>
